import React from 'react'
import './TopMenu.css'
import { Menu, Icon } from 'antd'
import { NavLink } from 'react-router-dom'
// import Cookies from 'js-cookie' // js-cookie
import { setKey, getKey } from '@/utils/Cookie'
import config from '@/utils/config'
import Auth from '@/utils/Auth'
const { SubMenu } = Menu
const menuItem = [
  {
    title: '个人预约',
    key: 'Home',
    path: '/Main/Home/Instructions',
    icon: 'home',
    IsShow: true
  },
  // {
  //   title: '团队预约',
  //   key: 'TeamAppointment',
  //   path: '/Main/Team',
  //   icon: 'team',
  //   IsShow: true
  // },
  {
    title: '预约记录',
    key: 'ReservationRecord',
    path: '/Main/ReservationRecord',
    icon: 'desktop',
    IsShow: true
  }
]
class TopMenu extends React.Component {
  state = {
    selectKey: 'Home'
  }
  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed
    })
  }
  componentWillMount() {
    // console.log(config.selectKey)
    // const data = Auth.getRoute()
    // if (data.key) {
    //   const key = menuItem.find(x => {
    //     return x.path === data.path
    //   })
    this.setState({
      selectKey: getKey('selectKey') ? getKey('selectKey') : 'Home'
    })
    // }
  }
  getMuinItemKey(item) {
    // console.log(item)
    // console.log(item.key)
    if (item.key == 'Home' || item.key == 'TeamAppointment') {
      Auth.setType(item.key)
    }

    this.setState({
      selectKey: item.key
    })
    setKey('selectKey', item.key)
    config.selectKey = item.key
  }
  render() {
    return (
      <>
        {/* style={{ width: 240 }} */}
        <div className="mentList">
          <Menu
            mode="horizontal"
            style={{ height: '100%', borderRight: 0 }}
            defaultSelectedKeys={[this.state.selectKey]}
          >
            {menuItem.map(x => {
              return (
                <Menu.Item key={x.key}>
                  <NavLink to={x.path} onClick={() => this.getMuinItemKey(x)}>
                    <span>{x.title}</span>
                  </NavLink>
                </Menu.Item>
              )
            })}
          </Menu>
        </div>
      </>
    )
  }
}

export default TopMenu
